import CsvPlayerInterface from './csv-player-interface';

class CsvPlayer implements CsvPlayerInterface {
    constructor(
        private externalId: string,
        private positionInLineup: string,
    ) {}

    getExternalId(): string {
        return this.externalId;
    }

    getLineupPosition(): string {
        return this.positionInLineup;
    }
}

export default CsvPlayer;
